<div class="wrapper flex flex-col h-full">
  <div class="heading text-type-2 mb-[20px] flex flex-row justify-between items-center">
    <div class="counter text-type-2">
      Add comments
    </div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>

  <app-text-area
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['comment']"
    [parentFormGroup]="form"
    class="w-full flex-1"
    controlName="comment"
  ></app-text-area>

  <div class="action-section w-full flex flex-row justify-start items-center mt-4">
    <app-primary-button
      (handleClick)="save()"
      class="w-full"
    >
      Close
    </app-primary-button>
  </div>
</div>

